import React from "react";
import { Game } from "../../interfaces/game.interface";
import { InfoIcon } from "./Icons";
import { useGameNavigator } from "../../hooks/useGameNavigator";

interface IActivityCard {
  game: Game;
}

export const ActivityCard: React.FC<IActivityCard> = ({ game }) => {
  const {navigateToGame} = useGameNavigator(game);

  return (
    <div className="flex flex-col gap-4 grow-0 shrink-0">
      <div
        className="w-80 h-48 flex justify-center items-center rounded-lg overflow-hidden relative cursor-pointer"
        style={{
          backgroundImage: `url(${game.thumbnail})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        onClick={() => navigateToGame()}
      >
        {/* <img className="absolute min-w-full min-h-full w-auto h-full rounded-xl" src={} alt={game.id} /> */}
      </div>
      <div className="flex items-center justify-between">
        <span className="text-white font-bold leading-5 text-[16px]">
          {game.id}
        </span>
        <div className="cursor-pointer" onClick={() => navigateToGame(true)}>
          <InfoIcon width={16} height={16} />
        </div>
      </div>
    </div>
  );
};
